// extracted by mini-css-extract-plugin
module.exports = {"root":"_404_root_1nQZC","inner":"_404_inner_2Ujn-","size":"_404_size_1XN0n","error":"_404_error_4pwfV","error2":"_404_error2_26Bxb"};